var exports = $.extend({}, require('core/search/search'));

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

function copyPriceRange(url1, url2) {
    let url1Obj;
    let url2Obj
    let base = 'https://dummy.com';
    try {
        if (url1.startsWith('http')) {
            try {
                url1Obj = new URL(url1);
            } catch (e) {}
        } else {
            try {
                url1Obj = new URL(url1, base);
            } catch (e) {}
        }
        if (url2.startsWith('http')) {
            try {
                url2Obj = new URL(url2);
            } catch (e) {}
        } else {
            try {
                url2Obj = new URL(url2, base);
            } catch (e) {}
        }
        let pmin = url1Obj.searchParams.get('pmin');
        let pmax = url1Obj.searchParams.get('pmax');
        if (pmin !== null && url2Obj.searchParams.has('pmin')) {
            url2Obj.searchParams.set('pmin', pmin);
        }
        if (pmax !== null && url2Obj.searchParams.has('pmax')) {
            url2Obj.searchParams.set('pmax', pmax);
        }
        return url2.startsWith('http') ? url2Obj.toString() : url2Obj.pathname + url2Obj.search;
    } catch (e) {
        return url2;
    }
}

function applyFilter() {
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .refinement-bar button.filter-apply-btn, .filter-value button, .swatch-filter button, .filter-value button.reset', // WGACA MODIFICATION - additional selector
        function (event) {
            const currentUrl = window.location.href;
            if(!window.isMobile()) {
                var category = $(event.currentTarget).closest('.refinement');

                if (category && category.hasClass('refinement-category')) {
                    localStorage.setItem('refinement-category', true);
                    return;
                }
            }
            //find new attr on Sort if selected, if not use the default

            // var selectedSort = $('select[name="sort-order"]').find('option[selected="selected"]');
            // if (selectedSort.data('id') != null) {
            //     var sortingRule = selectedSort.data('id');
            // } else {
            //     var sortingRule = $('select[name="sort-order"] option:selected').data('id');
            // }

            var sortingRule = "";
            var selectedSort = $('.sortDropdown').find('i.fa-check-circle');
            if (selectedSort.length) {
                sortingRule = selectedSort.parents('button').data('id');
            }
            //create a new url with the correct preferences
            if ($(this).attr('data-href').includes('srule')) {
                var refinementUrl = $(this).attr('data-href').replace(/(&srule=).*?(&|$)/,'$1' + sortingRule + '$2');
            } else if (!$(this).attr('data-href').includes('srule') && sortingRule != null) {
                var refinementUrl = $(this).attr('data-href');
                 if(refinementUrl.includes('?'))
                     refinementUrl = refinementUrl + '&srule=' + sortingRule;
                else
                     refinementUrl = refinementUrl + '?srule=' + sortingRule;
            } else {
                var refinementUrl = $(this).attr('data-href');
            }

            // apply price range filter
            // if(!$(this).hasClass('reset') && (location.href.indexOf("pmin") != -1  || location.href.indexOf("pmax") != -1)){
            //     var pMinPrice = parseInt(getQueryParameter(decodeURIComponent(location.href), "pmin").replace(/,/g, ''));
            //     var pMaxPrice = parseInt(getQueryParameter(decodeURIComponent((location.href)), "pmax").replace(/,/g, ''));

            //     refinementUrl = decodeURIComponent(refinementUrl);
            //     refinementUrl = updateQueryParameter(refinementUrl, "pmin", pMinPrice);
            //     refinementUrl = updateQueryParameter(refinementUrl, "pmax", pMaxPrice);
            // }


            var refinementId = $(this).closest('.horizontal-filter-refinement').attr('id');

            event.preventDefault();
            event.stopPropagation();
            $(this).trigger('search:filter', event);

            refinementUrl = copyPriceRange(currentUrl, refinementUrl);

            // Cancel previous request
            module.exports.searchShared$XHR?.abort?.();

            // Add Apply button latest refinement URL
            // Prevent Api call on checkbox selection for mobile
            if(window.isMobile() && $(this).is('.refinements li button')) {
                $('.helpButton')?.addClass('d-none');    // handling the visibility of overlapping .helpButton
                let attrId = $(this).closest('.card-body').attr('id');
                attrId = attrId.split('-').slice(2).join('-') // Get Selected attribute of filter
                const selectedLabelFilter =
                attrId == 'category' ? $(this).data('href') :
                $(this).find('.swatch-color-text').text()?.trim() || $(this).find('span').first().text()?.trim(); // Get Selected filter label
                const newFilterUrl = module.exports.methods.createSelectedFiltersUrl(refinementUrl, attrId, selectedLabelFilter);
                $('.filter-apply-btn').attr('data-href', newFilterUrl || refinementUrl);
                return;
            }

            // close refinment modal on click of apply and reset
            if(window.isMobile() && ($(this).is('.refinement-bar button.filter-apply-btn') || $(this).is('.refinement-bar button.reset'))) {
                // toggleRefinementDrawer('close');
                module.exports.methods.toggleRefinementDrawer('close');
            }

            module.exports.searchShared$XHR = $.ajax({
                url: refinementUrl,
                data: {
                    page: $('.grid-footer').data('page-number')
                },
                method: 'GET',
                timeout: 10000,
                beforeSend: function () {
                    $.spinner().start();
                },
                success: function (response, status, xhr) {
                    module.exports.methods.parseResults(response, xhr);
                    const permalink = $(response).find(':input.permalink').val();
                    refinementId = '#' + refinementId;
                    $(refinementId).find('.dropdown-toggle').trigger('click');
                    let updatedPermaLink = copyPriceRange(currentUrl, permalink);
                    history.replaceState(undefined, document.title, updatedPermaLink || refinementUrl);
                    $('body').trigger('search:filter--success');
                },
                complete: function () {
                    $.spinner().stop();
                }
            });
        });
}

exports.showMore = function () {
    // Show more products
    $('body').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        var showMoreUrl = $(this).data('url');
        const currentUrl = window.location.href;
        e.preventDefault();

        $.spinner().start();
        showMoreUrl = copyPriceRange(currentUrl, showMoreUrl);
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                const $newProductTiles = $(response).find('.product-grid-inner .plp-product-tile');
                $newProductTiles.appendTo('.product-grid-inner');

                const $updatedGridFooter = $(response).find('.grid-footer');
                $('.grid-footer').replaceWith($updatedGridFooter);

                updateSortOptions(response);
                $('body').trigger('search:showMore--success');
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            },
        });
    });
};

exports.productGridView = function () {
	$('.product-tile-layout .grid').on('click', function(){
		$('.product-tile-layout .grid').removeClass('active');
	    $(this).addClass('active');
	    if ($(this).hasClass('three-tile')) {
	        $('.product-grid-inner').addClass('three-tile');
	    }
	    else {
	        $('.product-grid-inner').removeClass('three-tile');
	    }
	});
};

exports.applyFilter = applyFilter;
exports.copyPriceRange = copyPriceRange;
module.exports = exports;
